import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { SectionLabel } from "@/components/SectionHeading";

const SENTENCE = "We don't just solve business problems — we design what comes next.";
const WORDS = SENTENCE.split(" ");
const HIGHLIGHT_FROM = WORDS.length - 3; // "what comes next."

const Word = ({ word, range, progress, highlight }) => {
  const opacity = useTransform(progress, range, [0.14, 1]);
  const y = useTransform(progress, range, [8, 0]);
  return (
    <span className="relative mr-[0.28em] mt-[0.12em] inline-block">
      <motion.span
        style={{ opacity, y }}
        className={highlight ? "gradient-text" : "text-brand-ink"}
      >
        {word}
      </motion.span>
    </span>
  );
};

export const ManifestoScroll = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start 0.85", "end 0.55"] });

  return (
    <section ref={ref} className="relative noise-overlay" data-testid="manifesto-section">
      <div className="relative z-10 max-w-[1500px] mx-auto px-6 md:px-12 py-16 md:py-28">
        <SectionLabel>01 — Who we are</SectionLabel>
        <p className="mt-12 flex flex-wrap font-heading font-extrabold tracking-tight text-3xl sm:text-5xl md:text-6xl lg:text-7xl leading-[1.12]">
          {WORDS.map((word, i) => {
            const start = i / WORDS.length;
            const end = start + 1 / WORDS.length;
            return (
              <Word
                key={i}
                word={word}
                range={[start, end]}
                progress={scrollYProgress}
                highlight={i >= HIGHLIGHT_FROM}
              />
            );
          })}
        </p>
      </div>
    </section>
  );
};
